 export const PETS = [
    {  nameId: "dog",
       title: 'dog',
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/pets/dog.jpg"
   },
   {   nameId: "cat",
       title: 'cat',
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/pets/cat.jpg"
   },
   {    nameId: "fish",
       title: 'fish',
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/pets/fish.jpg"
   },
   {    nameId: "bird",
       title: 'bird',
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/pets/bird.jpg"
   },
   {    nameId: "rabbit",
       title: 'rabbit',
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/pets/rabbit.jpg"
   },
   {    nameId: "reptilien",
       title: 'reptilien',
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/pets/reptilien.jpg"
   },
   {    nameId: "another",
       title: 'another',
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/pets/another.jpg"
   },
]
export const CHILDREN = [
   { 
       nameId: "baby",
       title: "baby",
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/children/baby.jpg"
   },
   {   nameId: "fourToSix", 
       title: "four to six",
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/children/five.jpg"
   },
   { 
       nameId: "sevenToNine",
       title: "seven to nine",
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/children/eight.jpg"
   },
   {   nameId: "tenToTwelve", 
       title: "ten to twelve",
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/children/eleven.jpg"
   },
   {   nameId: "twelvePlus", 
       title: "twelve+",
       url: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/children/mehr.jpg"
   },
   
]

export const AVATAR = {
   grand:"https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/users/mother.jpg",
   father:"https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/users/father.jpg",
   grandmother:"https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/users/grandmother.jpg",
   grandfather: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/users/grandfather.jpg",
   default: "https://ik.imagekit.io/gdvzxjp5x/parentsOnWeekend/photos/users/default.jpg"
}


export const FILTERPROPERTY =     {
    pets: {
      dog: false,
      cat: false,
      bird: false,
      fish: false,
      hamster: false,
      rabbit: false,
      reptilien: false
    },
    child: {
      baby: false,
      threeTofive: false,
      sixToNine: false,
      tenToTwelve: false,
      more: false
    }
}
